import { Box, Chip, Tooltip } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import { useAuth } from '../../hooks/useAuth';

/**
 * TenantInfo - Displays current tenant information
 * Only visible to users with 'admin' role
 */
function TenantInfo() {
  const { user } = useAuth();

  // Only show to admins
  if (!user || user.role !== 'admin') {
    return null;
  }

  // If no tenant info available, don't render
  if (!user.tenant) {
    return null;
  }

  const { tenant } = user;
  const isActiveTenant = tenant.status === 'active';

  return (
    <Tooltip 
      title={`Tenant: ${tenant.name} (ID: ${tenant.id})`}
      arrow
    >
      <Box sx={{ mr: 2 }}>
        <Chip
          icon={<BusinessIcon />}
          label={tenant.name}
          size="small"
          color={isActiveTenant ? 'default' : 'warning'}
          sx={{
            bgcolor: 'rgba(255, 255, 255, 0.15)',
            color: '#fff',
            '& .MuiChip-icon': {
              color: '#fff'
            },
            fontWeight: 500,
            maxWidth: 180,
            '& .MuiChip-label': {
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }
          }}
        />
      </Box>
    </Tooltip>
  );
}

export default TenantInfo;
